import { useCMSPage } from "../../../context/CMSContext";

const DEFAULT_STATS = [
  { icon: "ri-heart-line",      value: "Thousands", label: "Make-A-Wish donations",       sub: "supporting children's wishes" },
  { icon: "ri-recycle-line",    value: "95%+",      label: "Diverted from landfill",      sub: "measured, not estimated" },
  { icon: "ri-leaf-line",       value: "100%",      label: "Licensed facilities",         sub: "audited by our own team" },
  { icon: "ri-file-text-line",  value: "Every job", label: "Waste transfer note issued",  sub: "legally compliant always" },
];

export default function AboutEnvironment() {
  const { data: aboutCMS } = useCMSPage("about");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const envCMS: any = (aboutCMS as any)?.environment ?? {};

  const headline   = envCMS?.headline    ?? "Our environmental commitment.";
  const subheadline= envCMS?.subheadline ?? "Rubbish removal done right means rubbish that doesn't end up in the wrong place.";
  const stats      = envCMS?.stats?.length ? envCMS.stats : DEFAULT_STATS;

  return (
    <section className="py-20" style={{ background: "rgb(246,250,246)" }}>
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">

        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
            <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Planet First</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-cl-dark leading-tight mb-4">{headline}</h2>
          <p className="text-cl-dark/60 text-base font-semibold max-w-xl mx-auto leading-relaxed">{subheadline}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {stats.map((stat: { icon: string; value: string; label: string; sub: string }, i: number) => (
            <div key={i} className="bg-white rounded-2xl cartoon-card p-6 flex flex-col gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-cl-lime border-2 border-cl-dark cartoon-shadow-sm">
                <i className={`${stat.icon} text-cl-dark text-lg`}></i>
              </span>
              <div>
                <p className="font-black text-cl-dark text-2xl leading-none mb-1">{stat.value}</p>
                <p className="font-black text-cl-dark text-sm">{stat.label}</p>
                <p className="text-cl-dark/50 text-xs font-semibold mt-0.5">{stat.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
